import { OffHireTypeEnum } from '../../enum/off-hire-type.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateOffhireWebConsoleCommand {
  OffHireId: string;
  SiteId: string;
  CustomerId: string;
  ScaffoldId: string;
  OffhiredOn: string;
  SubmittedBy: string;
  RequestedBy: string;
  Comments: string;
  OffHireType: OffHireTypeEnum;
  OffsetFromUtc: number;
}


